module.exports = __webpack_public_path__ + "static/img/product10.1de4fe5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product10.png
// module id = XcZX
// module chunks = 1